import { render, staticRenderFns } from "./EventCategories.vue?vue&type=template&id=6e9ffb78&scoped=true&"
import script from "./EventCategories.vue?vue&type=script&lang=ts&"
export * from "./EventCategories.vue?vue&type=script&lang=ts&"
import style0 from "./EventCategories.vue?vue&type=style&index=0&id=6e9ffb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ffb78",
  null
  
)

export default component.exports